module.exports = __webpack_public_path__ + "static/media/2-sportivnye.4baafaa9.jpg";